import React from 'react';
import './GuestPopupTerms.css';

/**
 * GuestPopupTerms Component
 * 
 * A reusable component that displays Purebrand's Terms and Conditions content
 * Used in modals or standalone pages where legal terms need to be displayed
 * 
 * @param {Object} props - Component props
 * @param {string} props.className - Optional additional CSS class names
 * @param {boolean} props.compact - If true, uses more compact spacing
 * @returns {JSX.Element} Terms and Conditions content
 */
const GuestPopupTerms = ({ className = '', compact = false }) => {
  return (
    <div className={`terms-and-conditions-content ${compact ? 'compact' : ''} ${className}`}>
      <div className="terms-section">
        <p className="terms-paragraph">
          By using the Purebrand platform to access and view live product demonstrations, 
          you are agreeing to the{' '}
          <a 
            href="https://purebrand.io/privacy-policy" 
            target="_blank" 
            rel="noopener noreferrer"
            className="terms-link"
          >
            Purebrand Privacy Policy
          </a>
          {' '}and the{' '}
          <a 
            href="https://purebrand.io/terms-and-conditions" 
            target="_blank" 
            rel="noopener noreferrer"
            className="terms-link"
          >
            Purebrand Guest Terms of Use
          </a>
          , which contain terms that affect your legal rights, including disclaimers 
          of warranties, limitations on our liability, and a waiver of class actions.
        </p>
      </div>

      <div className="terms-section">
        <p className="terms-paragraph terms-highlight-box">
          <strong className="terms-important">Important:</strong> Purebrand may monitor 
          and record your interactions with others through the Purebrand platform for 
          quality control, marketing, and other lawful commercial purposes, and you should 
          expect no privacy or confidentiality in such interactions nor compensation or 
          credit for our use of recordings.
        </p>
      </div>

      <div className="terms-section">
        <p className="terms-paragraph terms-disclaimer">
          If you do not agree to the Purebrand Privacy Policy or the Purebrand Guest 
          Terms of Use, do not proceed to use the Purebrand platform.
        </p>
      </div>
    </div>
  );
};

export default GuestPopupTerms;